export { CustomerListPage } from './view/customer-list-page';
export { customerSagas } from './sagas';
export { default as customerSlice, getCustomer } from './slice';
